import React from 'react';
import PropTypes from 'prop-types';

import ConnectedSoftAccountStatusContent from './ConnectedSoftAccountStatusContent';
import SplitContainer from '../../connectedComponents/SplitContainer';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SOFT_ACCOUNT_STATUS_PATH
 */
export default class SoftAccountStatusPage extends React.Component {
    static propTypes = {
        usesNewStyles: PropTypes.bool,
    };

    render() {
        const { usesNewStyles } = this.props;

        return (
            <SplitContainer
                shouldShowSecondaryPanel={usesNewStyles}
                usesNewStyles={usesNewStyles}
            >
                <ConnectedSoftAccountStatusContent />;
            </SplitContainer>
        );
    }
}
